export default __webpack_public_path__ + "static/media/blood_donation_icon.eac05cf8.png";